<div class="post-container-header--wrapper">
  <div class="post--value-container"></div>
  <ark-post-user-options (openMobileContextMenu)="openMobileContextMenu()">
    <ark-options-menu
      (itemClicked)="itemClicked($event)"
      [options]="menu"
    ></ark-options-menu>
  </ark-post-user-options>
</div>
